import React, {PropTypes} from 'react';

const SelectStoreButton = ({
	active,
	onClick,
	subscription
}) => (
	<button key={subscription.id} 
					type="button" 
					className={`btn btn-link btn-radio ${active ? 'active' : ''}`}
					onClick={() => {onClick(subscription.id);}}>{subscription.name}
	</button> 
);

SelectStoreButton.propTypes = {
	active: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
	subscription: PropTypes.object.isRequired
};

export default SelectStoreButton;


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/SelectStoreButton.js
 **/